import ic_group from '../images/ic_group.png';
import ic_user from '../images/ic_user.png';
import ic_close from '../images/ic_close.png';
import ic_gallery from '../images/ic_gallery.png';
import ic_send from '../images/ic_send.png';

/** ================================
*  共通アイコン
*  ================================*/
export default class IconImages {
  // ユーザーアイコン
  static readonly ic_group = ic_group;
  static readonly ic_user = ic_user;

  // チャット用アイコン
  static readonly ic_close = ic_close;
  static readonly ic_gallery = ic_gallery;
  static readonly ic_send = ic_send;
}
